/**
 * LYT Communications - Fetch Helpers
 * Version: 1.0.0
 * Created: 2026-03-01
 *
 * Shared GAS CORS redirect handler.
 * Google Apps Script returns a 302 redirect to script.googleusercontent.com.
 * Browsers can't follow cross-origin redirects in fetch().
 * This function manually extracts the redirect URL from HTML and re-fetches.
 */

export const fetchWithRedirect = async (url, options = {}) => {
  try {
    const response = await fetch(url, { ...options, redirect: 'follow' });
    const text = await response.text();

    if (text.trim().startsWith('<') || text.includes('HREF=')) {
      const match = text.match(/HREF="([^"]+)"/i) || text.match(/href="([^"]+)"/i);
      if (match) {
        const redirectUrl = match[1].replace(/&amp;/g, '&');
        const redirectResponse = await fetch(redirectUrl);
        return redirectResponse.text();
      }
    }
    return text;
  } catch (err) {
    console.error('Fetch error:', err);
    throw err;
  }
};
